import Banner from "../Allcomponent/Banner"
import Cards from "../Allcomponent/cards"
import Lapone from "../Detials/lapone"
import Laptwo from "../Detials/laptwo"
import Lapthree from "../Detials/lapthree"
import Lapfour from "../Detials/lapfour"
function Alllap(){
    return(
        <>
        <Banner/>
        <Cards/>
         <Lapone/>
   <Laptwo/>
   <Lapthree/>
   <Lapfour/>
        </>
    )
}
export default Alllap